import { render, staticRenderFns } from "./lztl.vue?vue&type=template&id=dcf9995a&scoped=true"
import script from "./lztl.vue?vue&type=script&lang=js"
export * from "./lztl.vue?vue&type=script&lang=js"
import style0 from "./lztl.vue?vue&type=style&index=0&id=dcf9995a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf9995a",
  null
  
)

export default component.exports